import { NewLoginWidgetContextType } from './../models/new-login-widget-types';
import { Router } from '@angular/router';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'mem-okta-login-header',
  templateUrl: './new-login-widget-header.component.html',
  styleUrls: ['./new-login-widget-header.component.scss']
})
export class NewLoginWidgetHeaderComponent implements OnInit {

  @Input('pageType') pageType: NewLoginWidgetContextType = { controller: 'primary-auth' }
  isHidePassword: boolean=false;
  type: string = 'password';
  show: boolean = false;
  constructor(private router: Router) { }

  ngOnInit() {
  }

  /**
   * method for navigating into register page.
   */
  registerNow() {
    this.router.navigate(['/registration/step1']);
  }
    toggleShow() {
    var btnText = document.getElementById("myBtn");
    var vision = document.getElementById("vision");
    this.show = !this.show;
    if (this.show) {
      // this.type = "text";
      
      btnText.innerHTML = "Hide Passwords";
      // document.getElementById("input39").type = 'text';
      $("#input47").attr('type', 'text');
      $("#input39").attr('type', 'text');
      this.isHidePassword = true;
    }
    else {
      this.type = "password";
      $("#input47").attr('type', 'password');
      $("#input39").attr('type', 'password');
      btnText.innerHTML = "Show Passwords";
      this.isHidePassword = false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/new-login-widget/new-login-widget-header/new-login-widget-header.component.ts